import React from "react";
import { useTranslation } from "react-i18next";
import { StyledLabel } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";

import { FIDELITY_OPTIONS } from "@constants/index";

import { DimmedSelectInput } from "./styled";

type Props = {
    choiceFidelity: string;
};

export function LoyaltySelectField({ choiceFidelity }: Props) {
    const { t } = useTranslation();

    const selectValue =
        choiceFidelity === ""
            ? null
            : { label: choiceFidelity, value: choiceFidelity };

    return (
        <AvGroup>
            <StyledLabel className="required__clz mt-3" htmlFor="choiceFidelity">
                {t("Loyalty")}
            </StyledLabel>
            <DimmedSelectInput
                data-testid="fidelity-information-loyalty-select"
                value={selectValue}
                className="not-allowed-fidelity__clz"
                onChange={() => {}}
                options={FIDELITY_OPTIONS(t)}
                validate={{
                    required: {
                        value: true,
                        errorMessage: t("Please select a fidelity choice"),
                    },
                }}
                placeholder={t("Select")}
                name="mark"
                noOptionsMessage={() => t("No options")}
            />
        </AvGroup>
    );
}
